import { Drawer, Flex } from 'antd';
import { useContext } from 'react';
import { LibraryContext } from './context-provider';
import UploadFileCard from './upload-file-card';

export default function UploadDrawer({ open, setOpen }) {
   const { uploadFileList, setUploadFileList } = useContext(LibraryContext);

   return (
      <>
         <Drawer
            title="Uploading"
            placement="right"
            closable={false}
            open={open}
            styles={{ body: { padding: 0 } }}
            onClose={() => setOpen(false)}
         >
            <Flex vertical gap={16} align="center" style={{ width: '100%', padding: 16 }}>
               {uploadFileList.map((file, index) => {
                  return <UploadFileCard key={index} file={file} />;
               })}
            </Flex>
         </Drawer>
      </>
   );
}
